import * as rxfs from "rxfire/firestore";
import { tap } from "rxjs/operators";

function stackNow() {
  return new Error("RxFire observable created here").stack;
}

function refLabel(ref) {
  try {
    if (ref && ref.path) return ref.path;

    // Firebase compat / v8 internals
    if (ref && ref._delegate && ref._delegate.path) {
      return ref._delegate.path;
    }

    if (
      ref &&
      ref._query &&
      ref._query.path &&
      typeof ref._query.path.canonicalString === "function"
    ) {
      return ref._query.path.canonicalString();
    }

    if (
      ref &&
      ref._delegate &&
      ref._delegate._query &&
      ref._delegate._query.path &&
      typeof ref._delegate._query.path.canonicalString === "function"
    ) {
      return ref._delegate._query.path.canonicalString();
    }
  } catch (e) {}

  return "<unknown ref/query>";
}

function isPermissionError(err) {
  return (
    err &&
    (
      err.code === "permission-denied" ||
      err.code === "firestore/permission-denied" ||
      /missing or insufficient permissions/i.test(err.message || "") ||
      /permission-denied/i.test(err.message || "")
    )
  );
}

function debugObservable(label, source$, stack) {
  console.debug("[RxFire create]", label);

  return source$.pipe(
    tap({
      error: function (err) {
        if (!isPermissionError(err)) return;

        console.groupCollapsed("🔥 RxFire permission denied: " + label);
        console.error(err);
        console.log(stack);
        console.groupEnd();
      }
    })
  );
}

function wrapRxFireFn(name) {
  const original = rxfs[name];

  if (typeof original !== "function") {
    return original;
  }

  return function wrappedRxFire(refOrQuery, ...args) {
    const stack = stackNow();
    const label = name + " " + refLabel(refOrQuery);

    return debugObservable(
      label,
      original(refOrQuery, ...args),
      stack
    );
  };
}

// Wrapped RxFire Firestore exports
export const doc = wrapRxFireFn("doc");
export const docData = wrapRxFireFn("docData");
export const collection = wrapRxFireFn("collection");
export const collectionData = wrapRxFireFn("collectionData");
export const collectionChanges = wrapRxFireFn("collectionChanges");
export const sortedChanges = wrapRxFireFn("sortedChanges");
export const auditTrail = wrapRxFireFn("auditTrail");

// Re-export anything else RxFire provides, unchanged.
// Add more here if your app imports them.
export const fromRef = wrapRxFireFn("fromRef");
export const fromDocRef = wrapRxFireFn("fromDocRef");
export const fromCollectionRef = wrapRxFireFn("fromCollectionRef");
